import React, { useState, useEffect } from "react";
import { TextField, Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { registrationUser } from "../redux/asyncThunk/userActions";
import { useDispatch, useSelector } from "react-redux";
import { validateEmail } from "../utils/validateEmail";

export default function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.data);
  const messages = useSelector((state) => state.user.messages);

  useEffect(() => {
    if (user) {
      navigate("/main");
    }
  }, [navigate, user]);

  const [regData, setRegData] = useState({
    regLogin: "",
    regPassword: "",
    confirmRegPassword: "",
    accessKey: "",
  });
  const [message, setMessage] = useState({
    type: "",
    message: "",
  });

  useEffect(() => {
    setMessage(...messages);
  }, [messages]);

  const changeRegData = (event) => {
    setMessage({
      type: "",
      message: "",
    });
    setRegData((prev) => ({
      ...prev,
      [event.target.id]: event.target.value,
    }));
  };

  const handleRegButton = () => {
    if (
      regData.regLogin &&
      regData.regPassword &&
      regData.confirmRegPassword &&
      regData.accessKey
    ) {
      const checkPasswords =
        regData.regPassword === regData.confirmRegPassword ? true : false;

      if (checkPasswords) {
        if (validateEmail(regData.regLogin)) {
          dispatch(
            registrationUser({
              login: regData.regLogin,
              password: regData.regPassword,
              key: regData.accessKey,
            })
          );
        } else {
          setMessage({
            type: "error",
            message: "Введите корректный email",
          });
        }
      } else {
        setMessage({
          type: "error",
          message: "Пароли не совпадают",
        });
      }
    } else {
      if (!!regData.regLogin.length || !!regData.regPassword.length) {
        setMessage({
          type: "error",
          message: "Заполните все поля",
        });
      }
    }
  };

  return (
    <div>
      <div className="main_block_login">
        <div className={"reg_form"}>
          <Box
            onChange={(event) => changeRegData(event)}
            component={"form"}
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <Typography
              sx={{ color: "white", fontSize: "18px", fontWeight: "bold" }}
            >
              Регистрация
            </Typography>
            <TextField
              id="regLogin"
              label="Email"
              variant="filled"
              value={regData.regLogin || ""}
              sx={{ bgcolor: "white", width: "80%" }}
            />
            <TextField
              id="regPassword"
              label="Пароль"
              variant="filled"
              type="password"
              value={regData.regPassword || ""}
              sx={{ bgcolor: "white", width: "80%" }}
            />
            <TextField
              id="confirmRegPassword"
              label="Повторите пароль"
              variant="filled"
              type="password"
              value={regData.confirmRegPassword || ""}
              sx={{ bgcolor: "white", width: "80%" }}
            />
            <TextField
              id="accessKey"
              label="Введите ключ доступа"
              variant="filled"
              value={regData.accessKey || ""}
              sx={{ bgcolor: "white", width: "80%" }}
            />
            {message?.message ? (
              <Box sx={{ color: "white" }}>{message.message}</Box>
            ) : null}
            <Button
              variant="contained"
              onClick={() => handleRegButton(regData)}
            >
              Регистрация
            </Button>
          </Box>
        </div>
      </div>
      <div className="footer"></div>
    </div>
  );
}
